import { Model as BaseModel } from '@wizeoo/akm-common-lib';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { KeycloakService } from 'keycloak-angular';

/**
 * conteneur de données METIER (données, PAS objets uniques d'IHM NI méthodes statiques)
 * singleton
 * Même s'il existe des managers, les données utilisées sur plusieurs vues DOIVENT se trouver ici
 * Les collections utilisées par plusieurs vues DOIVENT se trouver ici
 * Le manager de ces collections ne fait que des traitements. Ici est la vérité
 */
export class Model extends BaseModel {

  public origin: string = 'AKM';

  constructor() { 
    super();
    
  }

  /** accesseur sur l'instance */
  public static getInstance(): Model {
    if (!this._instance) {
      this._instance = new Model();
    }
    return this._instance as Model;
  }

  /** toutes les visions de la vue menu.pop */
  // public allVision: VisionVO[] = null;

  /** injecté depuis appInit, lien vers le service d'Oauth */
  public security: KeycloakService = null;

  /** injecté depuis appComponent, référence au webworker */
  public webworker: Worker = null;

}
